import cn from 'classnames'
import { FC, useCallback, useMemo, useState } from 'react'

import { Translation, useSafetyTranslation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { AbsolutePopup, PopPaper, TPopupVertical } from 'core-components/library/popup'
import { IReportPeriod } from 'partner360/models/report/iReportPeriod'

import styles from './PeriodsOption.module.scss'

interface IPeriodsOptionProps {
  isSelected: boolean
  titleKey: string
  options: IReportPeriod[]
  selectedValue?: IReportPeriod
  onSelectReportPeriod: (period: IReportPeriod) => void
}

export const PeriodsOption: FC<IPeriodsOptionProps> = ({
  isSelected,
  titleKey,
  options,
  selectedValue,
  onSelectReportPeriod,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const t = useSafetyTranslation()

  const translatedTitle = useMemo(() => {
    const translated = t(titleKey)
    return translated.split(' ')[0]
  }, [t, titleKey])

  const matchedValue = useMemo(() => {
    return options.find((it) => it.Title === selectedValue?.Title)
  }, [options, selectedValue])
  const isMatch = isSelected && matchedValue !== undefined

  const handleToggle = useCallback(() => {
    setIsOpen((prevState) => !prevState)
  }, [])

  return (
    <div>
      {isOpen && <div className={styles.overlay} onClick={handleToggle} />}
      <AbsolutePopup
        verticalStartPosition={TPopupVertical.Bottom}
        visibilityCallback={() => isOpen}
        popupContent={() => {
          return (
            <PopPaper className={styles.popupContent}>
              {options.map((it) => {
                const isPeriodSelected = isSelected && it.Title === matchedValue?.Title
                return (
                  <Button
                    key={it.Title}
                    color={isPeriodSelected ? 'primary' : 'grey'}
                    className={cn(styles.button, {
                      [styles.button__selected]: isPeriodSelected,
                    })}
                    onClick={() => {
                      setIsOpen(false)
                      onSelectReportPeriod(it)
                    }}
                  >
                    {it.Title}
                  </Button>
                )
              })}
            </PopPaper>
          )
        }}
      >
        <Button
          color={isMatch ? 'primary' : 'grey'}
          className={cn(styles.btn, {
            [styles.button__selected]: isMatch,
          })}
          iconPosition="end"
          icon={cn(styles.iconCaret, 'kbase', 'kbase-chevron-bottom')}
          onClick={handleToggle}
        >
          {isMatch && selectedValue ? (
            `${translatedTitle}: ${selectedValue.Title}`
          ) : (
            <Translation text={titleKey} />
          )}
        </Button>
      </AbsolutePopup>
    </div>
  )
}
